/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, AppConfig } from '@core/models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HttpService {
  constructor(
    private httpClient: HttpClient,
    @Inject(APP_CONFIG) private config: AppConfig
  ) {}

  public get<T>(
    endpoint: string,
    headers?:
      | HttpHeaders
      | {
          [header: string]: string | string[];
        },
    params?:
      | HttpParams
      | {
          [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
        }
  ): Observable<T> {
    return this.httpClient.get<T>(`${this.config.apiUrl}${endpoint}`, { headers, params });
  }

  public post<T>(
    endpoint: string,
    body?: any,
    headers?:
      | HttpHeaders
      | {
          [header: string]: string | string[];
        },
    params?:
      | HttpParams
      | {
          [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
        }
  ): Observable<T> {
    return this.httpClient.post<T>(`${this.config.apiUrl}${endpoint}`, body, { headers, params });
  }

  public put<T>(
    endpoint: string,
    body: any,
    headers?:
      | HttpHeaders
      | {
          [header: string]: string | string[];
        },
    params?:
      | HttpParams
      | {
          [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
        }
  ): Observable<T> {
    return this.httpClient.put<T>(`${this.config.apiUrl}${endpoint}`, body, { headers, params });
  }

  public delete<T>(
    endpoint: string,
    body?: any,
    headers?:
      | HttpHeaders
      | {
          [header: string]: string | string[];
        }
  ): Observable<T> {
    return this.httpClient.delete<T>(`${this.config.apiUrl}${endpoint}`, { body, headers });
  }

  public getBlob<T>(
    endpoint: string,
    params?:
      | HttpParams
      | {
          [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
        },
    headers?: HttpHeaders | any
  ): Observable<any> {
    const options = { responseType: 'blob' } as any;

    return this.httpClient.get<T>(`${this.config.apiUrl}${endpoint}`, {
      headers,
      params,
      ...options,
    });
  }
}
